module.exports = __webpack_public_path__ + "img/aldi.8998c4e5.png";